// Shared password policy — keep aligned with pgx-api/app/services/password_validator.rb
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

export const PASSWORD_ERROR_MESSAGE =
  "Password minimal 8 karakter, harus mengandung huruf besar, huruf kecil, angka, dan karakter spesial.";

export function isPasswordValid(password) {
  return typeof password === "string" && PASSWORD_REGEX.test(password);
}
